import { Flex } from 'antd';
import { WEBSITE_PUBLIC_CDN } from 'util/constants';
import { lightning, brain, persona, web } from './svgs';
import styles from './agent-sections.module.css';

export default function FromIdeaToDeploymentSection() {
  return (
    <Flex
      vertical
      gap={48}
      align='center'
      justify='center'
      className={styles.fromIdeaToDeploymentSectionRoot}
      data-cy='agent3d-features'
    >
      <h1 className={styles.fromIdeaToDeploymentSectionTitle}>
        From Idea to Deployment – Fast & Easy
      </h1>
      <Flex
        align='center'
        justify='center'
        className={styles.fromIdeaToDeploymentSectionContent}
      >
        <Flex
          align='center'
          justify='center'
          className={styles.sectionCardWrapper}
        >
          <Flex vertical className={styles.sectionCardContent}>
            {persona}
            <span className={styles.violetText}>Set the character</span>
            <span className={styles.whiteText}>Choose persona</span>
          </Flex>
          <Flex vertical className={styles.sectionCardContent}>
            {brain}
            <span className={styles.violetText}>Define intelligence</span>
            <span className={styles.whiteText}>Choose Brain</span>
          </Flex>
          <Flex vertical className={styles.sectionCardContent}>
            {lightning}
            <span className={styles.violetText}>Quick setup</span>
            <span className={styles.whiteText}>Customize in Minutes</span>
          </Flex>
        </Flex>
        <Flex vertical className={styles.wideCard}>
          <span className={styles.webSvg}>{web}</span>
          <span className={styles.blueText}>Seamless integration</span>
          <span className={styles.whiteText}>Deploy anywhere</span>
          <img
            src={`${WEBSITE_PUBLIC_CDN}/deploy-anywhere-image.png`}
            className={styles.deployAnywhereImage}
            alt='Deploy anywhere'
          />
        </Flex>
      </Flex>
    </Flex>
  );
}
